<template>
  <section id="contact-us" class="bg-grey-light3 -mt-40 mb-20 overflow-hidden">
    <div class="md:container px-4 pt-63 lg:pb-0 pb-8">
      <div class="flex flex-wrap lg:flex-nowrap">
        <div class="w-full lg:w-1/2 text-center lg:mr-6 lg:mb-0 mb-8">
          <h3 class="font-bree-serif md:text-3xl mb-3">
            {{ $t('questions.title') }}
          </h3>
          <p>{{ $t('questions.subtitle') }}</p>
          <img v-lazy-load data-src="@/assets/img/img-team-doctors.png" alt="" class="mx-auto -mb-8">
        </div>
        <div class="w-full lg:w-1/2">
          <div class="flex flex-wrap items-center lg:mb-5 mb-3">
            <label class="py-2 w-full font-rubik-medium">{{ $t('name') }}*</label>
            <div class="relative w-full" :class="{'is-error': $v.form.name.$anyError}">
              <el-input v-model="$v.form.name.$model" type="text" :placeholder="$t('placeholderName')" />
              <span v-if="$v.form.name.$anyError" class="el-form-item__error">{{ $t('required') }}!</span>
            </div>
          </div>
          <div class="flex flex-wrap items-center lg:mb-5 mb-3">
            <label class="py-2 w-full font-rubik-medium">{{ $t('email') }}*</label>
            <div class="relative w-full" :class="{'is-error': $v.form.email.$anyError}">
              <el-input v-model="$v.form.email.$model" type="email" :placeholder="$t('placeholderEmail')" />
              <span v-if="$v.form.email.$anyError && !$v.form.email.required" class="el-form-item__error">{{ $t('required') }}</span>
              <span v-else-if="$v.form.email.$anyError && !$v.form.email.email" class="el-form-item__error">{{ $t('emailFormatInvalid') }}</span>
            </div>
          </div>
          <div class="flex flex-wrap items-center xl:mb-5 mb-3">
            <label class="py-2 w-full font-rubik-medium">{{ $t('message') }}*</label>
            <div class="relative w-full" :class="{'is-error': $v.form.message.$anyError}">
              <el-input
                v-model="$v.form.message.$model"
                :placeholder="$t('placeholderMessage')"
                type="textarea"
                :rows="4"
              />
              <span v-if="$v.form.message.$anyError" class="el-form-item__error">{{ $t('required') }}</span>
            </div>
          </div>
          <div class="flex flex-wrap md:flex-nowrap justify-between items-center">
            <recaptcha
              @error="onError"
              @success="onSuccess"
              @expired="onExpired"
            />
            <button class="btn btn-primary md:mt-0 mt-4 sm:w-auto w-full px-12 text-xl uppercase" @click="submitContact">
              {{ $t('submit') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const { required, email } = require('vuelidate/lib/validators')
export default {
  name: 'ContactUs',
  data () {
    return {
      form: {
        name: '',
        email: '',
        message: ''
      },
      tokenCaptcha: '',
      errorCaptcha: '',
      expiredCaptcha: false,
      loadingSubmit: false
    }
  },
  validations () {
    return {
      form: {
        name: {
          required
        },
        email: {
          required,
          email
        },
        message: {
          required
        }
      }
    }
  },
  methods: {
    submitContact () {
      this.loadingSubmit = true
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.loadingSubmit = false
        return
      }
      if (this.tokenCaptcha) {
        this.$store.dispatch('submitContact', this.form)
          .then((response) => {
            this.form = {
              name: '',
              email: '',
              message: ''
            }
            this.$v.$reset()
            this.loadingSubmit = false
            this.$swal.fire({
              icon: 'success',
              title: 'Berhasil Mengirim Formulir',
              timer: 1000
            }).then(() => {
              this.$router.push('/')
              this.$recaptcha.reset()
            })
          })
          .catch((error) => {
            this.loadingSubmit = false
            this.$recaptcha.reset()
            this.$swal.fire({
              icon: 'error',
              title: 'Gagal Kirim Formulir!',
              showConfirmButton: false,
              timer: 1000
            })
            throw new Error(error)
          })
      }
    },
    onSuccess (token) {
      this.tokenCaptcha = token
      this.errorCaptcha = ''
    },
    onExpired () {
      this.tokenCaptcha = ''
      this.errorCaptcha = 'Silakan melakukan verifikasi Captcha.'
    },
    onError (error) {
      this.tokenCaptcha = ''
      throw new Error(`captcha error happened: ${error}`)
    }
  }
}
</script>

<style scoped>

</style>
